// extracted by mini-css-extract-plugin
export default {"nav":"Breadcrumbs_nav__fddfX","homeImg":"Breadcrumbs_homeImg__oiKEY","crumbs":"Breadcrumbs_crumbs__3QN09","disabledLink":"Breadcrumbs_disabledLink__ueiMO"};